import React from 'react';
import all from '../../all';
import ProjectCard from '../../contaniers/project/ProjectCard';
import { Link } from 'react-router-dom';

const ViewAll = () => {
  return (
    <div className=" flex justify-center items-center text-center py- px-8">
      <div className=" flex flex-col  items-center   w-[100vw] h-fit shadow-xl rounded-[20px] py-16 px-4 ">
        <div className="flex items-center justify-between flex-row mb-4 w-full">
          <h1 className=" font-extrabold text-3xl">All projects: </h1>
          <Link to={'/'}>
            <h1 className=" text-2xl font-semibold hover:text-yellow-400 cursor-pointer">
              Back Home
            </h1>
          </Link>
        </div>
        <div className="flex flex-row justify-between gap-y-[30px] flex-wrap w-[100%]">
          {all.map((item, i) => (
            <ProjectCard item={item} i={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ViewAll;
